/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for pause icon.
 *
 * @author Ramani Govindaraju
 */
const Pause = props => (
  <SvgIcon viewBox="0 0 11 18" {...props}>
    <path
      d="M4.125 0H.375A.375.375 0 0 0 0 .375v17.25c0 .207.168.375.375.375h3.75a.375.375
      0 0 0 .375-.375V.375A.375.375 0 0 0 4.125 0M10.125 0h-3.75A.375.375 0 0 0 6
      .375v17.25c0 .207.168.375.375.375h3.75a.375.375 0 0 0 .375-.375V.375A.375.375
      0 0 0 10.125 0"
    />
  </SvgIcon>
);

export default Pause;



// WEBPACK FOOTER //
// ./src/js/icons/Pause.jsx